export default __webpack_public_path__ + "static/media/Asociaciones_scroll.517aed95.png";